import React from 'react'
import { Button, Container, Form, Nav, Navbar } from "react-bootstrap";
import { useNavigate,NavLink  } from "react-router-dom";

function Header() {
   const navigate = useNavigate()
     const logout = () => {
  localStorage.removeItem("isLoggedIn");
  navigate("/");
};
  return (
    <>
       <Navbar bg="primary" data-bs-theme="dark" style={{fontSize:"20px"}}>
        <Container>
          <Nav className="me-auto">
            <Nav.Link as={NavLink} to="/phonetracker">Phone Tracker</Nav.Link>
            <Nav.Link as={NavLink} to="/vpn002">VPN</Nav.Link>
            <Nav.Link as={NavLink} to="/gpscamera003">GPS Camera</Nav.Link>
          </Nav>
          <Nav className="ms-auto">
      <Button variant="light" onClick={logout}>Logout</Button>
    </Nav>
        </Container>
      </Navbar>
    </>
  )
}

export default Header
